import { CdkDragSortEvent, moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, Component, Input, OnInit, Output, ViewChild, EventEmitter, OnDestroy, OnChanges, SimpleChanges, signal, ElementRef } from '@angular/core';
import { FormBuilder, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatTable as MatTable, MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';
import * as fileSaver from 'file-saver';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import * as internal from 'stream';
import { distinctUntilChanged, filter, last, takeUntil, tap } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { Observable, of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { GridServiceService } from 'src/app/services/shared/grid-service.service';
import { MatSelectChange as MatSelectChange } from '@angular/material/select';
import { UpdateGridRowDto } from 'src/app/interfaces/Dtos/grid-data.dto';
import { F } from '@angular/cdk/keycodes';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { isNullOrUndef } from 'chart.js/dist/helpers/helpers.core';
import { element } from 'protractor';




/*------------------------FILTER HEADERS---------------------------------------------------------*/
export interface ColumnHeadersInfo {
  columnName: string,
  type: string,
  filterValues?: ColumnHeadersInfoValues[]
}


export interface ColumnHeadersInfoValues {
  value: string,
  icon?: string
}

/*-----------------------------------------------------------------------------------------------*/

export interface SortedGridColumn {
  id: number;
  nombre: string;
}

export interface ResponsibleGridColumn {
  nombre: string,
  place: number,
  isMainColumn: boolean
}

export interface GridFilter {
  importance: number
  column: string,
  filter_one?: any,
  filter_two?: any,
  isFilterDates?: boolean,
  isExternalFilter: boolean,
  filterType?: string
}

export interface IconColumn {
  IconValue?: string,
  IconColumnName?: string,
}

export interface DateColumn {
  columnName: string,
  showTime?: boolean
}

export interface GridColumnsConfiguration {
  ShowAddButton?: boolean
  IconValue?: string,
  IconColumnName?: string,
  hiddenColumnNames: string[],
  dateColumns: DateColumn[],
  cardColum: string,
  cardValues: ResponsibleGridColumn[],
  listColumns?: string[],
  MultiIconColumns?: MultiIconColumn[],
  ActionColumn?: GridActionColumn
}

export interface GridActionColumn {
  ColumnName: string,
  Actions: GridAction[]
}

export interface GridAction {
  Description: string,
  ShowDescription: boolean
  IconUrl: string,
  ActionName: string,
  States?: GridActionState
}

export interface GridActionState {
  StateColumn: string,
  Condition: "IS" | "NOT" | "MIN" | "MAX"
  StateValues: GridActionStateIcon[]
}

export interface GridActionStateIcon {
  StateValue: any,
  StateIcon: string
}



export interface MultiIconColumn {
  columnName: string,
  propertyName: string,
  icons: MultiIconColumnValue[]
}

export interface MultiIconColumnValue {
  value: string,
  iconUrl: string
}

export interface GridSelect {
  name: string,
  value: string
}

export interface Gridsource {
  SourceColumn: string,
  Configuration: GridSourceConfiguration,
  SourceItems: GridSourceItem[]
}

export interface GridSourceConfiguration {
  ValueColumn: string,
  DescriptionColumn: string,
  ExtraDescription1Column?: string,
  ExtraDescription2Column?: string
}

export interface GridSourceItem {
  Id: number,
  Description: string,
  ExtraDescription1?: string,
  ExtraDescription2?: string
}


export interface SelectedSourceValues {
  ColumnName: string,
  ROW_ID: number,
  SourceItem: GridSourceItem
}


@Component({
  selector: 'neoris-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.css'],
  providers: [DatePipe]
})
export class GridComponent implements OnInit, AfterViewInit, OnDestroy {

  public GetActionIconURL(element, action): string {
      if (action.States !== undefined) {
        var stateColumnValue = element[action.States.StateColumn] ?? null

        var state = null;
        switch (action.States.Condition) {
          case "IS":
            state = action.States.StateValues.find(f => f.StateValue == stateColumnValue)
            break;
          case "NOT":
            state = action.States.StateValues.find(f => f.StateValue !== stateColumnValue)
            break;
          default:
            state = null
          // case "MIN":
          //   break;
          // case "MAX":
          //   break;
        }

        if ((state ?? null) !== null) {

          return state.StateIcon

        } else {
          return action.IconUrl
        }
      }

      return action.IconUrl
  }


  formatText(text: string) {
    return text.replace(/\|/g, '\n'); // usa | como separador
  }
  // private SelectedSourceValues: SelectedSourceValues[] = []

  /*--------------------------------FILTER HEADERS------------------------------*/

  public GetColumnFilterValues(columnName: string): ColumnHeadersInfoValues[] {
    var columnHeadersInfo = this.columnHeadersInfo.find(f => f.columnName == columnName)
    return columnHeadersInfo.filterValues
  }

  public columnHeadersInfo: ColumnHeadersInfo[] = []

  private GenerateColumnHeadersInfo(data: any[]) {


    // var lastFilterIndex = this.filters.length
    // var lastFilterColumn = "";
    // if (lastFilterIndex > 0) {
    //   var lastFilter = this.filters[lastFilterIndex - 1]

    //   if(lastFilter !== undefined){
    //     lastFilterColumn = this.filters[lastFilterIndex - 1].column
    //   }
    // }

    if (data.length > 0) {

      const groupedData = data.reduce((acc, item) => {
        Object.keys(item).forEach(key => {
          if (!acc[key]) {
            acc[key] = new Set();
          }
          if (Array.isArray(item[key])) {
            item[key].forEach(subItem => {
              if (subItem) {
                acc[key].add(JSON.stringify(subItem));
              }
            });
          } else {
            acc[key].add(item[key]);
          }
        });
        return acc;
      }, {});

      const result = Object.keys(groupedData).reduce((acc, key) => {
        acc[key] = Array.from(groupedData[key]).map(value => {
          return typeof value === 'string' && value.startsWith('{') && value.endsWith('}') ? JSON.parse(value) : value;
        });
        return acc;
      }, {});


      var currentFilters = this.columnHeadersInfo.filter(f => this.filters.some(filter => filter.column === f.columnName));


      // Excluir de listColumns todos los filtros que estén en filters
      const listColumnExceptLastFilter = this.listColumns.filter(columnName => {
        return !this.filters.some(filter => filter.column === columnName);
      });

      const multiIconColumnStringExceptLastFilter = this.multiIconColumnString.filter(columnName => {
        return !this.filters.some(filter => filter.column === columnName);
      });

      this.columnHeadersInfo = listColumnExceptLastFilter.map(columnName => {
        return {
          columnName: columnName,
          type: "list",// Ajusta el tipo según tus necesidades
          filterValues: result[columnName].map(value => {
            return { value: (value ?? '').toString() };
          })
        };
      });

      multiIconColumnStringExceptLastFilter.forEach(columnName => {

        //Obtener la configuracion de la columna
        const iconColumnConfiguration = this.GetIconColumnConfiguration(columnName);


        this.columnHeadersInfo.push({
          columnName: columnName,
          type: 'icon',
          filterValues: result[columnName].map(value => {

            var columnValue = value[iconColumnConfiguration.property].toString()
            var icon = iconColumnConfiguration.iconos.icons.find(f => f.value == columnValue).iconUrl
            //Obtener el valor del ícono

            return { value: columnValue, icon: icon };
          }).filter((v, i, a) => a.findIndex(t => t.value === v.value && t.icon === v.icon) === i)
        });

      });


      //Add default to icon column
      this.columnHeadersInfo.filter(f => f.type == 'icon').forEach(f => {
        f.filterValues.push({ value: '', icon: 'assets/images/empty_icon.svg' })
      })

      //Get Last Filter Current Values      
      currentFilters.forEach(f => {
        this.columnHeadersInfo.push({
          columnName: f.columnName,
          type: f.type,
          filterValues: f.filterValues
        })
      })


    }

  }

  /*--------------------------------------------------------------------------*/


  //MultiIconColumns
  multiIconColumns: MultiIconColumn[] = []
  multiIconColumnString: string[] = []
  actionColumn: GridActionColumn

  showFilterButton: boolean = true;
  showFilters: boolean = false;
  open_filter: string = "occurred"

  /*-----------------------Click functionality---------------------------*/

  public clicRowId: number = -1

  /*----------------------------------------------------------------------*/


  defaultFilterPredicate?: (data: any, filter: string) => boolean;
  private hiddenColumns: string[] = []
  private dateColumns: DateColumn[] = []

  public isRowCheck: boolean

  public isMiniGrid: boolean = false;
  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);
  destroyed = new Subject<void>();
  currentScreenSize: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  checkColumns = this._formBuilder.group({});
  public iconColumn: IconColumn = {}
  columns: SortedGridColumn[] = []
  displayedColumns: string[] = []
  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<any>(true, []);
  public CHECK_BOX_COLUMN_NAME: string = 'select'
  title: string = ""
  previousIndex: number = 0;
  private originalData: any

  private filters: GridFilter[] = []

  public miniGridDisplayColumns: string[] = []
  public responsibleShowColumns: ResponsibleGridColumn[] = []

  public _gridSources: Gridsource[] = []
  @Input()
  set GridSources(gridSources: Gridsource[]) {
    this._gridSources = gridSources
  }

  /*--------------------GRID SOURCES--------------------------------*/
  miniGridColumns: SortedGridColumn[] = [{
    id: 0,
    nombre: 'occurred'
  }]

  public IsColumnGridSource(columnName: string): Boolean {

    if (this._gridSources == undefined)
      return false

    var source = this._gridSources.find(f => f.SourceColumn == columnName)

    return source !== undefined;
  }

  public IsActioncolumn(columnName: string): Boolean {

    if (this.actionColumn == undefined) {
      // console.log("isaction False")
      return false;
    }


    let isActionColumn = this.actionColumn.ColumnName == columnName

    // console.log("isAction",isActionColumn)

    return isActionColumn

  }

  public GetSourceValues(columnName: string) {
    var sourceItems = this._gridSources.find(f => f.SourceColumn == columnName).SourceItems;

    // console.log("sourceItems", sourceItems)

    return sourceItems;
  }


  ShowSourceValue(columnName: string, element: any): { Id: any, Description: string, ExtraDescription1: string, ExtraDescription2: string } | null {
    let result = { Id: -1, Description: "", ExtraDescription1: "", ExtraDescription2: "" };

    const sourceConfiguration = this._gridSources.find(f => f.SourceColumn == columnName);
    if (!sourceConfiguration) return null;

    // const selected = this.SelectedSourceValues.find(
    //   f => f.ColumnName === columnName && f.ROW_ID === element.ROW_ID
    // );

    // if (selected) {
    //   result = selected.SourceItem;
    // } else {
    result.Id = element[sourceConfiguration.Configuration.ValueColumn];
    result.Description = element[sourceConfiguration.Configuration.DescriptionColumn];

    if (sourceConfiguration.Configuration.ExtraDescription1Column !== undefined) {
      result.ExtraDescription1 = element[sourceConfiguration.Configuration.ExtraDescription1Column];
    }
    else {
      result.ExtraDescription1 = ""
    }

    if (sourceConfiguration.Configuration.ExtraDescription2Column !== undefined) {
      result.ExtraDescription2 = element[sourceConfiguration.Configuration.ExtraDescription2Column];
    }
    else {
      result.ExtraDescription2 = ""
    }


    return result;
  }


  public UnchangedChanges(): number {
    const unchangedData = this.dataSource.data.filter(element => (element.GRID_STATUS === 'CHANGED' || element.GRID_STATUS === 'NEW'));
    return unchangedData.length
  }



  onSourceValueChanged(newValue: any, columnName: string, element: any): void {
    // if(element.GRID_STATUS !== 'NEW'){
    const sourceConfiguration = this._gridSources.find(f => f.SourceColumn == columnName);
    var newValueSourecItem = sourceConfiguration.SourceItems.find(f => f.Id == newValue)

    element[sourceConfiguration.Configuration.ValueColumn] = newValueSourecItem.Id;
    element[sourceConfiguration.Configuration.DescriptionColumn] = newValueSourecItem.Description;


     if (sourceConfiguration.Configuration.ExtraDescription1Column !== undefined) {
      element[sourceConfiguration.Configuration.ExtraDescription1Column] = newValueSourecItem.ExtraDescription1;
    }

    if (sourceConfiguration.Configuration.ExtraDescription2Column !== undefined) {
      element[sourceConfiguration.Configuration.ExtraDescription2Column] = newValueSourecItem.ExtraDescription2
    }




    element.GRID_STATUS = element.GRID_STATUS == "NEW" ? "NEW" : 'CHANGED';
    // }else{
    //   //NEW ITEMS FUNCTIONALITY

    // }
  }

  public ADD(event) {
    event.stopPropagation();
    this.addClickEvent.emit()
  }

  public SAVE_CHANGES() {
    var newAndUnchangedData = this.dataSource.data.filter(f => f.GRID_STATUS == 'CHANGED' || f.GRID_STATUS == 'NEW')

    this.saveChangesEvent.emit(newAndUnchangedData);
  }

  /*-----------------------------------------------------------------*/

  @Input()
  set ShowChecks(showChecks: boolean) {
    this.isRowCheck = showChecks
  }

  @Input()
  set Filter(gfilters: GridFilter[]) {
    //Delete values for gfilterColumns
    var gfilterColumns = gfilters.map(f => f.column)
    this.filters = this.filters.filter(f => !gfilterColumns.includes(f.column))

    gfilters = gfilters.filter(f => f.filter_one !== undefined)

    gfilters.forEach(gfilter => {
      if (this.filters.length > 0) {
        this.filters = this.filters.sort((a, b) => a.importance - b.importance)
      }

      this.filters.push(gfilter)
    });

    this.AplyFilters()
  }

  public selectedValues: { [columnName: string]: any } = {};

  frenchDateToDbDate(date: string): Date {
    let [day, month, year] = date.split('/')
    const dateObj = new Date(+year, +month - 1, +day)

    return dateObj
  }

  @Input()
  set GridTitle(title: string) {
    this.title = title
  }

  public listColumns: string[] = []

  private gridSelect: GridSelect[] = []
  public ShowAddButton: boolean = false;

  @Input()
  set ColumnsConfiguration(gridColumnsConfiguration: GridColumnsConfiguration) {

    //Show Add Button
    if((gridColumnsConfiguration.ShowAddButton ?? false)){
      this.ShowAddButton = true
    }else{
      this.ShowAddButton = false
    }

    //ExtraFuntionColumns
    this.hiddenColumns = gridColumnsConfiguration.hiddenColumnNames;
    this.dateColumns = gridColumnsConfiguration.dateColumns;
    this.iconColumn = {
      IconValue: gridColumnsConfiguration.IconValue,
      IconColumnName: gridColumnsConfiguration.IconColumnName
    }

    if (gridColumnsConfiguration.MultiIconColumns !== undefined) {
      this.multiIconColumns = gridColumnsConfiguration.MultiIconColumns

      this.multiIconColumns.forEach(f => {

        f.icons.push({ value: 'All', iconUrl: 'assets/controlTowers/empty_icon.svg' })
      })

      this.multiIconColumnString = this.multiIconColumns.map(f => f.columnName)
    } else {
      this.multiIconColumns = []
      this.multiIconColumnString = []
    }


    if (gridColumnsConfiguration.ActionColumn !== undefined) {
      this.actionColumn = gridColumnsConfiguration.ActionColumn
    }

    this.miniGridDisplayColumns.push(gridColumnsConfiguration.cardColum)
    gridColumnsConfiguration.cardValues.forEach(f => {
      this.responsibleShowColumns.push(f)
    })

    if (gridColumnsConfiguration.listColumns !== undefined) {
      this.listColumns = gridColumnsConfiguration.listColumns
    }
  }

  private GetIconColumnConfiguration(columnName: string): { iconos: MultiIconColumn, property: string } {

    let iconosColumna = this.multiIconColumns.find(f => f.columnName == columnName)

    var property = iconosColumna.propertyName

    return { iconos: iconosColumna, property: property }
  }

  public icons(columnName: string, valoresColumna: any): string[] {

    var iconColumnConfiguration = this.GetIconColumnConfiguration(columnName)

    var valores = valoresColumna.map(valorColumna => {

      var icon = iconColumnConfiguration.iconos.icons.find(f => f.value.toString() == valorColumna[iconColumnConfiguration.property].toString())

      if (icon != undefined) {
        valorColumna.icon = icon.iconUrl
      } else {
        valorColumna.icon = "";
      }

      return valorColumna
    })

    return valores;
  }

  public isListColumn(columnName: string): boolean {
    return this.listColumns.filter(f => f == columnName).length > 0
  }


  public isMultiColumnIconColumn(columnName: string): boolean {
    return this.multiIconColumnString.filter(f => f == columnName).length > 0
  }

  private groupListColumnValues(data, columnName: string): any[] {
    let newAr = data.map((item, index, arr) => {
      return { name: columnName, value: item[columnName] }
    })
    const result = newAr.reduce((acc, d) => {
      const found = acc.find(a => a.value === d.value);
      if (!found) {
        acc.push({ name: d.name, value: d.value })
      }
      return acc;
    }, []);
    return result
  }

  public getColumnValues(columnName): GridSelect[] {
    return this.gridSelect.filter(f => f.name == columnName)
  }

  @Input()
  set Data(data: any) {




    this.filters = []

    this.originalData = data
    if (this.displayedColumns.length == 0) {
      const gridColumnNames: string[] = this.GenerateGridColumnNames(data);
      this.GenerateDataToHideSortedFunctionality(gridColumnNames)
    }

    this.gridSelect = []

    this.displayedColumns.forEach(listColumn => {

      const listColumnValues = this.groupListColumnValues(this.originalData, listColumn)
      listColumnValues.forEach(f => {
        this.gridSelect.push(f)
      })
    })

    this.SetDefaultValueToSelectFilters()
    this.showFilters = false

    this.GenerateColumnHeadersInfo(data)

    this.dataSource = new MatTableDataSource(this.originalData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;


    setTimeout(() => {
      if (data.length > 0) {
        this.clicRowId = data[0].ROW_ID


        console.log("clicRowId", this.clicRowId)
      }
    }, 500);

  }

  private SetDefaultValueToSelectFilters() {
    this.displayedColumns.forEach(listColumn => {
      this.selectedValues[listColumn] = 'All'
    })
  }


  public VisualizeSourceValue(element: any) {

  }

  public optionChange(column, event: MatSelectChange) {

    const columnName: string = column
    const value: String = event.value

    this.ClearGridFilter(columnName, value)
    this.ApplyGridFilter(columnName, value, 'equals')

  }

  private ClearGridFilter(columnName, value) {

    if (value !== 'All') {
      if (this.filters == undefined) {
        this.filters = []
      }

      if (this.filters.length > 0) {
        this.filters = this.filters.filter(f => f.column !== columnName).sort((a, b) => a.importance - b.importance)
      }
    }
  }

  private ApplyGridFilter(columnName, value, filterType = 'equals') {

    if (value !== 'All') {
      if (this.filters == undefined) {
        this.filters = []
      }

      let gFilter: GridFilter = {
        column: columnName,
        importance: 0,
        filter_one: value,
        isFilterDates: false,
        isExternalFilter: false,
        filterType: filterType
      }

      this.filters.push(gFilter)
      this.AplyFilters()

    } else {
      this.filters = this.filters.filter(f => f.column !== columnName).sort((a, b) => a.importance - b.importance)
      this.AplyFilters()
    }
  }


  private AplyFilters() {
    let filterData = this.originalData;


    var externalFilters = this.filters.filter(f => f.filter_one !== undefined && f.isExternalFilter == true)
    //Apply external filters
    if (externalFilters.length > 0) {
      filterData = filterData.filter(data => {
        return externalFilters.some(filterValue => data[filterValue.column].toString().trim().toLowerCase().includes(filterValue.filter_one.toString().trim().toLowerCase()));
      });
    }

    //Limpiar los filtros vacíos o undefined
    // f.filter_one !== '' &&
    var _filters = this.filters.filter(f => f.filter_one !== undefined && f.isExternalFilter == false)
    _filters = _filters.sort((a, b) => a.importance + b.importance)



    // console.log("external/filters", externalFilters, _filters)


    _filters.forEach(filter => {

      // filter.filter_one !== '' && 
      if (filter.filter_one !== undefined) {
        if (filter.isFilterDates == false) {
          const filterValue = filter.filter_one.toString().trim().toLowerCase()

          filterData = filterData.filter(data => {
            const dataValue = data[filter.column].toString().trim().toLowerCase()

            let filterType = filter.filterType == undefined ? 'equals' : filter.filterType


            if (filterType == 'equals') {
              if (dataValue == filterValue) {
                return data
              }
            }
            else if (filterType == 'contains') {
              if (dataValue.indexOf(filterValue) >= 0) {
                return data
              }
            }

            if (filterType == 'icon') {
              // Lógica para buscar sobre la propiedad icon
              const iconColumn = this.GetIconColumnConfiguration(filter.column);
              if (iconColumn) {
                if (filterValue !== '') {
                  const iconValue = data[filter.column].map(columnData => columnData[iconColumn.property]).join(' ');

                  if (iconValue.indexOf(filterValue) >= 0) {
                    return data;
                  }
                } else {
                  if (dataValue == filterValue)
                    return data
                }

              }
            }
          })
        }

      }
    })


    this.GenerateColumnHeadersInfo(filterData)

    this.dataSource.data = filterData;

  }

  @Output() cellClickEvent = new EventEmitter<any>();
  @Output() addClickEvent = new EventEmitter<any>();
  @Output() saveChangesEvent = new EventEmitter<any>();
  // @Output() actionClickEvent = new EventEmitter<any>();

  @ViewChild('gridContainer') gridContainer: ElementRef;

  @ViewChild('grid') grid: MatTable<any>;

  private gridServiceServiceSubscription: Subscription
  private clearSelectedRowsSubscription: Subscription
  private updateRowSubscription: Subscription
  private moveRowSubscription: Subscription

  constructor(private _formBuilder: UntypedFormBuilder,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private gridServiceService: GridServiceService,
    public breakpointObserver: BreakpointObserver) {
    this.responsiveGridFuncionality()
    this.gridServiceEvents()
  }

  ngOnInit(): void {
    this.defaultFilterPredicate = this.dataSource.filterPredicate;
    this.DetectCheckedColumnChanges();
  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.gridContainer?.nativeElement?.focus();
    }, 100);
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
    this.gridServiceServiceSubscription.unsubscribe()
    this.clearSelectedRowsSubscription.unsubscribe()
    this.updateRowSubscription.unsubscribe()
    this.moveRowSubscription.unsubscribe()
  }



  gridServiceEvents() {
    this.gridServiceServiceSubscription = this.gridServiceService.selectedRowsObservable.subscribe(s => {
      this.gridServiceService.sendSelectedRows(this.selection.selected)
    })

    this.clearSelectedRowsSubscription = this.gridServiceService.clearSelectedRowsObservable.subscribe(s => {
      this.selection.clear()
    })

    this.updateRowSubscription = this.gridServiceService.UpdateRowObservable.subscribe(s => {
      this.actionOnRow(s)
    })

    this.moveRowSubscription = this.gridServiceService.moveRowObservable.subscribe(s => {
      this.moveRow(s)
    })
  }

  private moveRow(movement: string) {
    if (movement == 'up') {
      this.moveRowUp()
    } else {
      this.moveRowDown()
    }
  }

  private moveRowUp() {
    const currentIndex = this.dataSource.data.findIndex(element => element.ROW_ID === this.clicRowId);
    const nextEventIndex = currentIndex - 1;
    const previousEvent = this.dataSource.data[nextEventIndex];
    if (previousEvent) {
      this.clicRowId = previousEvent.ROW_ID;
      this.movePaginateToShowRow(nextEventIndex)
      this.gridServiceService.emitMoveRowData(previousEvent)
    }
  }

  private moveRowDown() {
    const currentIndex = this.dataSource.data.findIndex(element => element.ROW_ID === this.clicRowId);
    const nextEventIndex = currentIndex + 1;
    const nextEvent = this.dataSource.data[nextEventIndex];
    if (nextEvent) {
      this.clicRowId = nextEvent.ROW_ID;
      this.movePaginateToShowRow(nextEventIndex)
      this.gridServiceService.emitMoveRowData(nextEvent)
    }
  }

  private movePaginateToShowRow(index: number) {
    if (index !== -1) {
      // Calcular la página a la que pertenece el registro
      const pageSize = this.paginator.pageSize;
      const pageIndex = Math.floor(index / pageSize);

      // Cambiar a la página correspondiente
      this.paginator.pageIndex = pageIndex;
      this.dataSource.paginator = this.paginator;
    }
  }

  private actionOnRow(row: UpdateGridRowDto) {
    switch (row.action) {
      case 'update':
        this.updateRow(row);
        break;
      case 'delete':
        this.deleteRow(row);
        break;
    }
  }

  private deleteRow(row: UpdateGridRowDto) {
    // // Buscar el objeto en el dataSource
    const data = this.dataSource.data;
    var dataWithoutDeletedRow = data.filter(item => item[row.columnName] !== row.value);
    this.dataSource.data = dataWithoutDeletedRow
    this.grid.renderRows();
    // const index = data.findIndex(item => item[row.columnName] === row.value);

    // if (index !== -1) {
    //   // Actualizar el dato
    //   data[index] = { ...data[index], ...row.newData };
    //   this.dataSource.data = data

    //   // Refrescar el grid
    //   this.grid.renderRows();
    // }
  }

  private updateRow(row: UpdateGridRowDto) {
    // Buscar el objeto en el dataSource
    const data = this.dataSource.data;
    const index = data.findIndex(item => item[row.columnName] === row.value);

    if (index !== -1) {
      // Actualizar el dato
      data[index] = { ...data[index], ...row.newData };
      this.dataSource.data = data

      // Refrescar el grid
      this.grid.renderRows();
    }
  }

  public ToggleFilters() {
    if (this.showFilters == true) {
      this.showFilters = false;

      this.filters = this.filters.filter(f => f.isExternalFilter == true)
      this.AplyFilters()


    } else {
      this.showFilters = true;
    }
  }

  public setDefaultFilter() {
    this.dataSource.filterPredicate = this.defaultFilterPredicate;
  }

  private responsiveGridFuncionality() {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this.currentScreenSize = this.displayNameMap.get(query) ?? 'Unknown';
            if (this.currentScreenSize == 'XSmall') {
              this.isMiniGrid = true
              this.miniGrid()
            } else {
              this.isMiniGrid = false
              this.normalGrid()
            }
          }
        }
      });
  }

  private normalGrid() {
    if (this.grid !== undefined) {
      this.grid.renderRows();
    }
  }

  private miniGrid() {
    if (this.grid !== undefined) {
      this.grid.renderRows();
    }
  }

  public _displayedColumns(): string[] {
    if (this.columns.length > 0) {
      if (this.isMiniGrid) {
        return this.miniGridDisplayColumns
      } else {
        return this.displayedColumns
      }
    }
  }

  setupFilter(column: string) {
    this.dataSource.filterPredicate = (d: any, filter: string) => {
      let textToSearch = ''
      if (d[column] !== undefined) {
        textToSearch = (d[column] || '').toString() && (d[column] || '').toString().toLowerCase() || '';
      }
      return textToSearch.indexOf(filter) !== -1;
    };
  }

  public GetIfIsNewRow(row: any): boolean {

    if (row.hasOwnProperty('isNew')) {
      if (row['isNew'] == true) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  }

  public ColumnValue(columnName: string, value: any): any {
    if (value !== undefined || value !== null || value !== '') {
      const dateColumn = this.dateColumns.filter(f => f.columnName == columnName);
      if (dateColumn.length > 0) {
        let showHour = true
        if (dateColumn[0].showTime !== undefined) {
          showHour = dateColumn[0].showTime
        }
        let format = 'MM/dd/yyyy';
        if (showHour == true) {
          format = 'MM/dd/yyyy HH:mm:ss'
        }
        let date_value = this.datePipe.transform(value, format)
        return date_value
      }
    }

    return value
  }

  applyFilter(columnName: string, event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;


    this.ClearGridFilter(columnName, filterValue.trim().toLowerCase())
    this.ApplyGridFilter(columnName, filterValue.trim().toLowerCase(), 'contains')
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applySelectFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  private GenerateGridColumnNames(data: any[]): string[] {
    let columnNames: string[] = []

    if (data.length > 0) {

      if (this.isRowCheck) {
        columnNames.push(this.CHECK_BOX_COLUMN_NAME)
      }

      let objectKey = Object.keys(data[0])
      for (let index = 0; index < objectKey.length; index++) {
        const column = objectKey[index];

        if (this.hiddenColumns.find(f => f == column) == undefined) {
          columnNames.push(column)
        }

      }
    } else {

    }

    return columnNames;
  }

  public onToggleChange(column: string, event: MatButtonToggleChange): void {

    this.filters = this.filters.filter(f => f.column !== column).sort((a, b) => a.importance - b.importance)

    var clickeICons = event.value;

    if (clickeICons.length == 0) {
      // this.ApplyGridFilter(column, "", 'icon')
      this.AplyFilters()
    } else {
      clickeICons.forEach(f => {
        const value: String = f
        this.ApplyGridFilter(column, value, 'icon')

      })
    }
  }


  private GenerateDataToHideSortedFunctionality(gridColumns: string[]) {

    gridColumns.forEach((columnName, index) => {
      this.AddCheckedColumns(columnName, true)
    })


    gridColumns.forEach((columnName, index) => {
      this.AddDisplayedColumn(columnName)
    })


    gridColumns.forEach((columnName, index) => {
      this.AddSortedGridColumn(columnName, index)
    })
  }

  private DetectCheckedColumnChanges() {
    this.checkColumns.valueChanges.subscribe(_checkColumns => {
      let columnNamesuno = this.CheckedColumnsToColumnNames(_checkColumns)
      let sortedGridColumns = this.ColumnNamesToSortedGridColumn(columnNamesuno)
      let sortedGridColumnsAscending = this.SortedGridColumnToAscending(sortedGridColumns)
      let columnNames = this.SortedGridColumnsToColumnNames(sortedGridColumnsAscending)
      this.displayedColumns = columnNames
    })
  }

  private AddCheckedColumns(columnName: string, checked: boolean) {
    this.checkColumns.addControl(columnName, new UntypedFormControl(checked), { emitEvent: false })
  }

  private AddDisplayedColumn(columnName: string) {

    this.displayedColumns.push(columnName);
  }

  private AddSortedGridColumn(columnName: string, index: number) {
    this.columns.push({
      id: index,
      nombre: columnName
    })
  }

  private SortedGridColumnToAscending(gridColumns: SortedGridColumn[]): SortedGridColumn[] {
    return gridColumns.sort((a, b) => {
      return a.id - b.id;
    });
  }

  private GetSortedGridColumn(columnName: string): SortedGridColumn {
    const sortedGridColumn = this.columns.find(f => f.nombre == columnName)

    if (sortedGridColumn == undefined) {


      const gridColumnErrror: SortedGridColumn = {
        id: -1,
        nombre: "Column not found"
      }
      return gridColumnErrror
    }



    return sortedGridColumn
  }

  private ColumnNamesToSortedGridColumn(columnNames: string[]): SortedGridColumn[] {
    let sortedGridColumns: SortedGridColumn[] = []

    columnNames.forEach(columnName => {
      let sortedGridColumn = this.GetSortedGridColumn(columnName)
      sortedGridColumns.push(sortedGridColumn)
    })

    return sortedGridColumns
  }

  private CheckedColumnsToColumnNames(_checkColumns: any) {

    let stringCheckedColumns: string[] = []
    let checkedColumnsArray = Object.entries(_checkColumns)
    checkedColumnsArray.filter(f => f[1] == true).forEach(checkColumn => {
      stringCheckedColumns.push(checkColumn[0] as string)
    })

    return stringCheckedColumns
  }

  private SortedGridColumnsToColumnNames(sortedGridColumns: SortedGridColumn[]): string[] {
    let sortedStringColumnNames: string[] = []

    sortedGridColumns.forEach(sortedGridColumn => {
      sortedStringColumnNames.push(sortedGridColumn.nombre)
    })

    return sortedStringColumnNames;
  }

  onSorted(event: CdkDragSortEvent) {

    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    let sortedItems = event.container.getSortedItems();

    let i: number = 0;
    this.columns.forEach(f => {
      f.id = i;
      i++;
    })

    let sortedColumnNames: SortedGridColumn[] = []
    for (let index = 0; index < sortedItems.length; index++) {
      const element = sortedItems[index];

      const checkBox = element.element.nativeElement as HTMLInputElement
      const name = checkBox.getAttribute('ng-reflect-name')
      const checked = checkBox.classList.contains('mat-mdc-checkbox-checked')
      if (checked) {
        let sortedGridColumn = this.GetSortedGridColumn(name as string)
        sortedColumnNames.push(sortedGridColumn)
      }
    };



    let sortedGridColumns = this.SortedGridColumnToAscending(sortedColumnNames);
    let columnNames = this.SortedGridColumnsToColumnNames(sortedGridColumns)
    this.displayedColumns = columnNames;
  }

  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataSource.data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, `excel_${new Date().getTime()}.xlsx`);
  }

  exportAsCsv() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataSource.data);

    const scvWs = XLSX.utils.sheet_to_csv(ws)

    fileSaver.saveAs(new Blob([scvWs]), `csv_${new Date().getTime()}.csv`);


  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
  }

  public cellClick(event: any, element: any, action?: any) {

    if (this.open_filter !== '') {
      this.open_filter = ''
    } else {
      this.clicRowId = element.ROW_ID

      if (action !== undefined) {

        element.ACTION = action
        this.cellClickEvent.emit(element);


      } else {
        element.ACTION = undefined
        this.cellClickEvent.emit(element);
      }
    }

    event.stopPropagation();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  public openFilter(columnName) {
    this.open_filter = columnName
  }

  // public actionClic(element: any, action: any){

  //   let gridAction = {
  //       element: element,
  //       action: action
  //   }

  //   this.actionClickEvent.emit(gridAction);
  // }
}
